import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";

export class WorkerEndReason extends Resource {
    public override type = 'workerEndReasons';

    @prop()
    @required()
    public name!: string;

}